import {Tooltip } from 'antd'
const resource_lotus_pic = [
  {
      "Number":1,
      "Name":"XiaoYuWan",
      "Plant type":"Small size",
      "Flower color":"White",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/0b1d6eb6-ee66-4e6e-96d6-978479fe9c62.jpg"
  },
  {
      "Number":2,
      "Name":"QiuYu",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d0e5c938-7352-47e8-839d-8a96e9ebe70a.jpg"
  },
  {
      "Number":3,
      "Name":"BaiLongXiZhu",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/4ee6f737-562c-4b69-9bf5-d10f86e24fcf.png"
  },
  {
      "Number":4,
      "Name":"XieZhao",
      "Plant type":"Small size",
      "Flower color":"White with red tips",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f31b9d22-3dd9-47b7-bbeb-0fc4fa57787f.jpg"
  },
  {
      "Number":5,
      "Name":"XingSeChunShan",
      "Plant type":"Small to medium size",
      "Flower color":"Orange",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/cb16c12e-95c9-45b1-9d90-97bb03884075.jpg"
  },
  {
      "Number":6,
      "Name":"BanJianHong",
      "Plant type":"Medium size",
      "Flower color":"Light red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/13cf9088-2c96-4b70-94b7-09cab71283e0.png"
  },
  {
      "Number":7,
      "Name":"BaiYunJin",
      "Plant type":"Medium size",
      "Flower color":"Light yellow",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f15d6314-7ceb-4f7c-a464-2cdd15661719.png"
  },
  {
      "Number":8,
      "Name":"CuiYuHanXiang",
      "Plant type":"Small to medium size",
      "Flower color":"Light green",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3eedbe59-2775-4098-91e6-7e07a870e343.JPG"
  },
  {
      "Number":9,
      "Name":"WuXingHongLian",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c2af6f52-ed82-4f7b-a8c1-b589e96c7cba.JPG"
  },
  {
      "Number":10,
      "Name":"YingErHong",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/8de8a8df-0bbf-4826-9516-edcbac9638fd.jpg"
  },
  {
      "Number":11,
      "Name":"HongJieLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3a33902d-9d84-4020-b1c2-bf7363dbd768.jpg"
  },
  {
      "Number":12,
      "Name":"HongShuangXi",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5805c0e4-f46f-4b36-9de5-f0d0a0a10f93.jpg"
  },
  {
      "Number":13,
      "Name":"XingHuo",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2b29b42e-a5b7-4fb5-8644-934f88210172.jpg"
  },
  {
      "Number":14,
      "Name":"YiZhangFen",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/b5179373-f3ae-4428-850f-a264e5cbeb7d.JPG"
  },
  {
      "Number":15,
      "Name":"QingCheng",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/cd16cae6-c500-41af-b6d3-07a373bf551b.JPG"
  },
  {
      "Number":16,
      "Name":"XianNv",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/079d16ca-78c9-4e74-a5d1-2b4cee444d04.jpg"
  },
  {
      "Number":17,
      "Name":"YouYiHong2Hao",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/515240e1-052f-42e6-a783-c737bb11baf8.JPG"
  },
  {
      "Number":18,
      "Name":"ChiWan",
      "Plant type":"Small to medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/96794d8b-46d5-4a46-a3c1-8e03c4edabee.png"
  },
  {
      "Number":19,
      "Name":"WanShouHong",
      "Plant type":"Small to medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5e12ae68-74db-4612-8060-9980d5ec2815.jpg"
  },
  {
      "Number":20,
      "Name":"HongXiaYingRi",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/89f42e04-8baf-4023-837d-fa42e8a3fb7b.jpg"
  },
  {
      "Number":21,
      "Name":"ZiXiaDongLai",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ca45135c-7744-454e-9929-fc44026670db.JPG"
  },
  {
      "Number":22,
      "Name":"DongFangHong",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1d2b8b0b-19fc-4321-9158-9deab11ac12f.jpg"
  },
  {
      "Number":23,
      "Name":"RiMian",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/22459bf6-e7c6-494c-affa-942bd1663d79.jpg"
  },
  {
      "Number":24,
      "Name":"XiYingMen",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2813e6e7-ec9e-4d1a-b5dd-ff6e3f60f453.jpg"
  },
  {
      "Number":25,
      "Name":"XiaoJieBai",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c596f0ca-63a7-4a16-b63e-c442ee8e660d.jpg"
  },
  {
      "Number":26,
      "Name":"QinHuaiCaiDeng",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5e3214c2-3400-4b3d-9d26-74fa7969a880.jpg"
  },
  {
      "Number":27,
      "Name":"XinHongXing",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f390b2cc-8da3-4fd0-b405-d45dadb87697.jpg"
  },
  {
      "Number":28,
      "Name":"JinSiQue",
      "Plant type":"Medium size",
      "Flower color":"Yellow-white with green tips",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/0a242f82-1b82-423e-bfff-bbfc830223a8.jpg"
  },
  {
      "Number":29,
      "Name":"CuiYuLian",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/7be90916-2a2f-4c8c-a124-fc0f8fb9c3e6.jpg"
  },
  {
      "Number":30,
      "Name":"GuanNiangQiWu",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c633ec5a-b154-438f-ab32-dcedbd00dc60.jpg"
  },
  {
      "Number":31,
      "Name":"HuangJinShiDai",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1e9d4ed4-5a27-4abe-a989-9bebe992e54a.JPG"
  },
  {
      "Number":32,
      "Name":"HuangShuai",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e714ce0f-51ac-46da-8824-44854c74351e.jpg"
  },
  {
      "Number":33,
      "Name":"LongFei",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1397d19a-1280-4131-a8cf-03cec41b6296.jpg"
  },
  {
      "Number":34,
      "Name":"MeiRenXiao",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/46d08944-6eff-45ae-af00-6f538785194b.jpg"
  },
  {
      "Number":35,
      "Name":"XiZiZuiWu",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/42303efe-a232-4935-877a-33201225711b.jpg"
  },
  {
      "Number":36,
      "Name":"XueWu",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/fa9b23b3-c485-484f-9da2-1a5c2b59d03c.jpg"
  },
  {
      "Number":37,
      "Name":"YuLian",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/0d5c8692-9a89-468d-b7e0-2b7518e37c1f.jpg"
  },
  {
      "Number":38,
      "Name":"JinLingNingCui",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/561825e8-156d-41a6-8d4b-720174cc8393.JPG"
  },
  {
      "Number":39,
      "Name":"BingJiao",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e370b0f4-e7ea-42cb-962c-ffd97a17337a.png"
  },
  {
      "Number":40,
      "Name":"JianWu",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d44b4999-05c8-41db-bf34-43af846a5945.JPG"
  },
  {
      "Number":41,
      "Name":"JinWuCangJiao",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/7775f7e6-ead6-478e-9b3b-44efaf6dafc7.jpg"
  },
  {
      "Number":42,
      "Name":"JingHong",
      "Plant type":"Large size",
      "Flower color":"Dark red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f281051f-640c-46e2-b740-1651725a3993.JPG"
  },
  {
      "Number":43,
      "Name":"ZhongGuoHong.JiaQing",
      "Plant type":"Small to medium size",
      "Flower color":"Dark red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2561ede6-ffad-42ec-b0fb-25d75c3cc23f.jpg"
  },
  {
      "Number":44,
      "Name":"ZhongGuoHong.ShangHai",
      "Plant type":"Small size",
      "Flower color":"Dark red",
      "Flower shape":"Semi-double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ac2b6673-ce92-4a16-abc6-911a9ed583d9.JPG"
  },
  {
      "Number":45,
      "Name":"WuZhi2",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":""
  },
  {
      "Number":46,
      "Name":"JinZhuLuoYuPan",
      "Plant type":"Small size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/b9ccc92c-19e9-4bc8-8bf2-f371e1bcb9ba.jpg"
  },
  {
      "Number":47,
      "Name":"BaiHuaJianLian",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/adf67e17-43be-4416-9c0b-81d8355c9c61.JPG"
  },
  {
      "Number":48,
      "Name":"BaiWuFei",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/7b5c505e-1ac8-4fce-98b8-15c713120837.png"
  },
  {
      "Number":49,
      "Name":"ChenGuang",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/f870b145-3131-4bc4-9673-081583395d8a.png"
  },
  {
      "Number":50,
      "Name":"DaBaiLian",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/69748717-f0a0-4677-ba44-bb074b39727d.jpg"
  },
  {
      "Number":51,
      "Name":"eLian12",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/c1c5f37b-9a7d-49bc-b2b1-18acb75051a9.jpg"
  },
  {
      "Number":52,
      "Name":"TaiKongLian6",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/3dcec8f2-832f-47f7-b92c-27f2aeb89076.JPG"
  },
  {
      "Number":53,
      "Name":"WeiShanHuBaiHe",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/11c2cce2-539b-4059-b198-cbf842fcb8f8.jpg"
  },
  {
      "Number":54,
      "Name":"ZhouOu",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/989ed264-2194-4f7a-b745-1ccde6b8eeb6.JPG"
  },
  {
      "Number":55,
      "Name":"BaiGeDanBan",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/44923edb-fb31-4381-b7e3-19e3896c2f68.png"
  },
  {
      "Number":56,
      "Name":"BeiJingWanLian",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/13fd90cd-f626-4085-9f63-c8b56d4f9e5f.png"
  },
  {
      "Number":57,
      "Name":"HunSha",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/e750abdf-40af-4130-b077-891a8a6cc243.jpg"
  },
  {
      "Number":58,
      "Name":"XiaMenWanLian",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/64298450-9b22-4b59-aaba-ce2442ad0b11.JPG"
  },
  {
      "Number":59,
      "Name":"BeiJingHongHuaOu",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":""
  },
  {
      "Number":60,
      "Name":"BoLiGongZhu",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/92f37c82-dc44-40c8-b6b6-d77e0b1fd244.png"
  },
  {
      "Number":61,
      "Name":"BoAiLian",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/b7833805-4802-4136-bf29-a142020b1f21.png"
  },
  {
      "Number":62,
      "Name":"eLian5",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/7bfe8c2f-a856-4918-9a14-896df9379ff2.jpg"
  },
  {
      "Number":63,
      "Name":"LiuYueXue",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/06913246-9c73-4e33-8947-0fd52777c0fe.jpg"
  },
  {
      "Number":64,
      "Name":"ShiJiaZhuangBaiLian",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/66fb7917-725e-4daf-91d1-7434ae984b03.JPG"
  },
  {
      "Number":65,
      "Name":"TianZiZi",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/a430b84b-4a1a-4401-9d93-c751e78beb31.JPG"
  },
  {
      "Number":66,
      "Name":"ZhuWeiBa",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/a6540280-a98d-4249-9e0a-e73eb7bd5013.png"
  },
  {
      "Number":67,
      "Name":"JianXuan17",
      "Plant type":"Large size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/9efb0f44-230a-462f-b55a-54c9c4a9a5ab.JPG"
  },
  {
      "Number":68,
      "Name":"JianXuan31",
      "Plant type":"Large size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/ee648011-18c6-4d50-818f-1a326ba54ccd.JPG"
  },
  {
      "Number":69,
      "Name":"LianHuYeOu",
      "Plant type":"Large size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/4977717c-6aeb-4df5-b818-c72994c5cd59.jpg"
  },
  {
      "Number":70,
      "Name":"FenFuRong",
      "Plant type":"Medium to large size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/b41a7e28-39d1-4a1e-bec5-5377e637671e.jpg"
  },
  {
      "Number":71,
      "Name":"SiMeiHuang",
      "Plant type":"Small to medium size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/e3ff7090-752b-4d4e-981b-b40292536ab2.jpg"
  },
  {
      "Number":72,
      "Name":"XianNvSanHua",
      "Plant type":"Small to medium size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/043505e4-576d-428e-bfe3-7ed956f66e7d.jpg"
  },
  {
      "Number":73,
      "Name":"ErQiao",
      "Plant type":"Medium size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/c315332a-0933-45eb-83c2-82c9bf2b2311.jpg"
  },
  {
      "Number":74,
      "Name":"MoShanHong",
      "Plant type":"Medium size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2d50ecb8-2b1a-4922-9e70-a42803786d58.jpg"
  },
  {
      "Number":75,
      "Name":"YanHuaPiaoXiang",
      "Plant type":"Medium size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/c3bf74fa-1718-4967-bd95-405744af01f0.JPG"
  },
  {
      "Number":76,
      "Name":"ZhiYan1",
      "Plant type":"Medium size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/22967153-6f3c-439b-8ae4-a3e43a02bc19.JPG"
  },
  {
      "Number":77,
      "Name":"YangGuiRen",
      "Plant type":"Medium size",
      "Flower color":"White with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/92839290-788a-45f9-8df4-651e06424bda.jpg"
  },
  {
      "Number":78,
      "Name":"MeiZhongHuang",
      "Plant type":"Large size",
      "Flower color":"Pinkish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/6f4a81ca-e37d-4286-88af-68213d157e8e.jpg"
  },
  {
      "Number":79,
      "Name":"JingFenShaoYao",
      "Plant type":"Medium to large size",
      "Flower color":"Pinkish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/479e1cfb-6909-4ab2-b09c-4f23fe3f71fb.JPG"
  },
  {
      "Number":80,
      "Name":"eYing",
      "Plant type":"Small to medium size",
      "Flower color":"Pinkish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/fcc0c234-330f-4633-86d0-c40e084cf4bd.jpg"
  },
  {
      "Number":81,
      "Name":"HaiNanZhouOu",
      "Plant type":"Medium size",
      "Flower color":"Pinkish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/789e647e-1ddf-4e75-b344-3d0ebcf53f95.jpg"
  },
  {
      "Number":82,
      "Name":"HongGuang",
      "Plant type":"Medium size",
      "Flower color":"Pinkish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/bd55b8cb-62aa-45de-88a1-669e85fe91ed.jpg"
  },
  {
      "Number":83,
      "Name":"ZaoOu",
      "Plant type":"Medium size",
      "Flower color":"Pinkish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/22fef3e8-09ef-4018-b224-a817e5a074f5.jpg"
  },
  {
      "Number":84,
      "Name":"KeZhi1Hao",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/65e38ba3-cd5e-46c5-ac08-8bd35ebead28.JPG"
  },
  {
      "Number":85,
      "Name":"HongXiangLian",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/ba0fd48e-0e82-431a-a02a-56e27afd14d6.jpg"
  },
  {
      "Number":86,
      "Name":"ManTianXing",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/8b438324-01a9-429d-af60-f9840fbcda87.JPG"
  },
  {
      "Number":87,
      "Name":"MeiZhongHong",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/beb8ef1b-1efb-48e0-93fa-48a9d85cefa3.jpg"
  },
  {
      "Number":88,
      "Name":"TaiKongLian36",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/ddc640f6-efbd-49ce-9758-4290e8fe1aaa.JPG"
  },
  {
      "Number":89,
      "Name":"TaiKongLian4",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/00b524a6-10b0-4ade-ab06-1d23479cb66d.JPG"
  },
  {
      "Number":90,
      "Name":"XiangJianHuan",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/3b289dc5-4539-490e-9071-0ce864da2fae.jpg"
  },
  {
      "Number":91,
      "Name":"HanXiao",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/8d4a0077-ae26-4dca-8d31-19a87896eed1.jpg"
  },
  {
      "Number":92,
      "Name":"QiuXing",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/d625b66c-2c71-4740-9aa0-7f5bc1ed78f8.JPG"
  },
  {
      "Number":93,
      "Name":"DaXiQueTou",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":""
  },
  {
      "Number":94,
      "Name":"HongLingLong",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/56e39a0c-c175-47f2-b329-e67fd83d965d.JPG"
  },
  {
      "Number":95,
      "Name":"XiaoMeiHong",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2ed8c970-b9bc-46a1-99b6-c5e5fb31d1c2.jpg"
  },
  {
      "Number":96,
      "Name":"LouMingLian",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/bd7d4ae7-4aa0-4915-9d87-2293c1e64a2c.JPG"
  },
  {
      "Number":97,
      "Name":"WuFeiLian",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/11f7b46e-c2f4-46e8-be99-f44fffc7d289.JPG"
  },
  {
      "Number":98,
      "Name":"XiaoSanSe",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/fc447873-9cc7-43f9-a585-a9236f305557.JPG"
  },
  {
      "Number":99,
      "Name":"FenXiuQingSha",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/e578d9f2-fec6-49c5-a3da-e151b1caa3b3.JPG"
  },
  {
      "Number":100,
      "Name":"QianShou",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/e07708db-33a4-4b91-bdba-2dbe9039f4e0.jpg"
  },
  {
      "Number":101,
      "Name":"YanXia",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/55a3a944-00ab-4e7f-8a86-4ab8cb3aa0ed.JPG"
  },
  {
      "Number":102,
      "Name":"YuHuBingXin",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/77bfdb5b-3124-43ab-b257-7d95219a1a8f.JPG"
  },
  {
      "Number":103,
      "Name":"ChangShun1",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/a7c4ca91-3419-4e67-8282-f92b7cd811fc.png"
  },
  {
      "Number":104,
      "Name":"DanHe-CuoWu",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":""
  },
  {
      "Number":105,
      "Name":"FenBaWang",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/9e67c8d5-ad68-4d6f-b8e7-ff6982499495.JPG"
  },
  {
      "Number":106,
      "Name":"FenLian",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/d20816e8-bceb-4ea4-9da8-3baf0e3a6bc9.jpg"
  },
  {
      "Number":107,
      "Name":"JinShangTianHua",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/a308153f-20ad-4b17-8ac0-384a3988a5cd.JPG"
  },
  {
      "Number":108,
      "Name":"TaiKongLian20",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/23c9a038-c0ea-4739-a8c1-b48c2c7f81cd.JPG"
  },
  {
      "Number":109,
      "Name":"TaiKongLian2",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/1252d666-35ab-4758-8b12-2e053cf3b12e.JPG"
  },
  {
      "Number":110,
      "Name":"WuNiang",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/f9fb9262-3c8c-41b2-a43e-f20c07344ef7.JPG"
  },
  {
      "Number":111,
      "Name":"XuanLian",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/990ea0af-1387-4286-8677-b64ebe5c76b4.jpg"
  },
  {
      "Number":112,
      "Name":"YinZhanLian",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/af9c51d1-d554-4610-9f65-eecdc7e81228.jpg"
  },
  {
      "Number":113,
      "Name":"BiCuiLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/991a5583-9325-4674-ac75-4b8ce15ff7a6.png"
  },
  {
      "Number":114,
      "Name":"DanFengChaoYang",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/cdffb4e7-134f-44bd-b00e-0cb4e2f058e6.jpg"
  },
  {
      "Number":115,
      "Name":"DianJiangHong",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/3ac51658-8493-4a42-8465-03363f055f7e.JPG"
  },
  {
      "Number":116,
      "Name":"DongHuZhaoXia",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/60ed823a-de2e-4468-8e62-cc973d713823.jpg"
  },
  {
      "Number":117,
      "Name":"DuLi",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/4d39dff8-376d-44fa-86d9-3e0a9edeb206.jpg"
  },
  {
      "Number":118,
      "Name":"FeiTian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/6fa5007e-6879-4774-aadb-cffc034cc89e.JPG"
  },
  {
      "Number":119,
      "Name":"FengHuangOu",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":""
  },
  {
      "Number":120,
      "Name":"FuRongLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/a151c9e5-b1df-4d09-9291-f73356cb0df6.jpg"
  },
  {
      "Number":121,
      "Name":"GanLian62",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/beff4ae4-385c-4f80-980b-13ffd6dc63b2.JPG"
  },
  {
      "Number":122,
      "Name":"GuangChangLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/0bca8d0b-d4c3-4e09-b139-8d0dc5a8cab5.JPG"
  },
  {
      "Number":123,
      "Name":"HanLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/760c5b1c-1309-4363-ad2d-19c0abf228d6.jpg"
  },
  {
      "Number":124,
      "Name":"JiangXiaYeOu",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/b9d70170-4f1c-47f1-b529-bd670e1356c1.JPG"
  },
  {
      "Number":125,
      "Name":"MaoJie",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/daa3872c-b55d-4e5a-a208-8b244e1e466f.jpg"
  },
  {
      "Number":126,
      "Name":"QinHuaiDengYing",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/bfbf2e40-c30c-4f64-becd-82660843d71e.jpg"
  },
  {
      "Number":127,
      "Name":"ShaoXingHongLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/93615e88-a155-4bc8-a444-0a197da3df8a.jpg"
  },
  {
      "Number":128,
      "Name":"TaiKongLian1",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/095be8b7-51c5-4e67-9ed1-53f4453f7328.JPG"
  },
  {
      "Number":129,
      "Name":"TaiYeShengLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/bc364c2a-2c46-4c9e-9fb5-b3fc9aabd776.jpg"
  },
  {
      "Number":130,
      "Name":"TianJinLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/dc758de5-be45-489b-baf8-184fd7d6e5f1.JPG"
  },
  {
      "Number":131,
      "Name":"WuNiChang",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/406bd411-0195-4cfa-bf01-b4e704d3e7d1.JPG"
  },
  {
      "Number":132,
      "Name":"XiQueLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/74f6bbc6-a7e8-40e5-9105-7217a6a8a1e7.jpg"
  },
  {
      "Number":133,
      "Name":"XiangBaiLian1",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/594383ba-ae85-4690-a68f-93b8aef10f19.JPG"
  },
  {
      "Number":134,
      "Name":"XuanLian5",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":""
  },
  {
      "Number":135,
      "Name":"YaZhouLian(HuBeiPaiHuJuQun)",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/4c13f9ce-7413-4739-978f-f5b9c53f2b44.jpg"
  },
  {
      "Number":136,
      "Name":"YingBinFuRong",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/294477dc-f7bd-4ddc-93fe-82e9b352b8e3.jpg"
  },
  {
      "Number":137,
      "Name":"ZhongGuoGuDaiLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2b28a5f6-d162-4a60-a296-c85e6ba484f1.JPG"
  },
  {
      "Number":138,
      "Name":"ZhongGuoGuDaiLian-432",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/84b62784-2ad9-4149-adf2-ad6a23454670.jpg"
  },
  {
      "Number":139,
      "Name":"ZhongGuoGuDaiLian-543",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/38a9d3a9-23a3-4b1a-853b-8b49fc12451d.JPG"
  },
  {
      "Number":140,
      "Name":"ZuiBei",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/e0696e5e-799d-4e3b-8c3b-e200772fbc54.png"
  },
  {
      "Number":141,
      "Name":"ShaoBanJinXia",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/dc0f81bb-8a05-4b6e-8f09-3ffa2a266d38.jpg"
  },
  {
      "Number":142,
      "Name":"CuiYu",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/5b17940e-abe7-4894-b035-c87450c3f146.JPG"
  },
  {
      "Number":143,
      "Name":"DongHe",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/9225bfa6-96d2-42be-9ce6-4995cfeff657.JPG"
  },
  {
      "Number":144,
      "Name":"HongMei",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/220b5edc-b0ac-4116-abea-4a667757e84c.jpg"
  },
  {
      "Number":145,
      "Name":"HongYingZhuLian",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/6c4e2e46-4755-41b1-b4a0-775006097667.jpg"
  },
  {
      "Number":146,
      "Name":"JianXuan35",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/7b3465b2-5f3f-4fc6-832d-37fae52f6a7a.JPG"
  },
  {
      "Number":147,
      "Name":"MaNaoHong",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/668e4855-4405-4de9-b13c-4015bc2f0060.jpg"
  },
  {
      "Number":148,
      "Name":"MiaoQuLian",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2c873676-57ce-4741-8d86-5d6c9d08fd8d.JPG"
  },
  {
      "Number":149,
      "Name":"QinHuaiHuaDeng",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/1a561274-cae5-42ce-ac0d-46d7cea24efb.jpg"
  },
  {
      "Number":150,
      "Name":"ShiLiHe1",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/6723ff7f-111d-4090-bed6-989e71c1af7c.JPG"
  },
  {
      "Number":151,
      "Name":"TaiKongLian58",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/cf054c22-5434-4819-b9a2-212a52630f97.JPG"
  },
  {
      "Number":152,
      "Name":"WeiShanHongLian",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/4482fce0-559b-40d2-8a87-c5cc80f8b106.jpg"
  },
  {
      "Number":153,
      "Name":"XiHuHongLian",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/dc6935a1-e4bb-4413-8f44-3b2b8a6e6303.png"
  },
  {
      "Number":154,
      "Name":"XuanLian6",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2a632409-7a0a-4d6d-97f5-4e0062b6a439.jpg"
  },
  {
      "Number":155,
      "Name":"YeHongLian",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/1361d5b2-e3c7-4e8f-b115-33957e0c363a.JPG"
  },
  {
      "Number":156,
      "Name":"YingLian",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/fe6891e9-93f0-4244-bdae-b51b05aef76e.JPG"
  },
  {
      "Number":157,
      "Name":"ZiXia",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/fae6798f-fb2d-44c8-bb51-246c94575f63.jpg"
  },
  {
      "Number":158,
      "Name":"ZhuYiShiZhe",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/373c9117-f99f-4632-960d-b2e4dd376414.JPG"
  },
  {
      "Number":159,
      "Name":"ZiXianBaoLai",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/7e1cd151-f9ac-43db-9fdf-d6fa54b43d8d.png"
  },
  {
      "Number":160,
      "Name":"BaiYangDianHongLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/05d1bd2f-6334-47b1-9a6e-f44e1a6fee74.png"
  },
  {
      "Number":161,
      "Name":"BaiYeLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/b98c1d1d-7e95-481e-8b95-a15fd4b0de5f.JPG"
  },
  {
      "Number":162,
      "Name":"DaHongPao",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/abc8001e-23b9-46b7-8f60-9d76f9324ecc.jpg"
  },
  {
      "Number":163,
      "Name":"DongHuHongLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/ac48f05c-c796-4010-908a-e692060b6475.JPG"
  },
  {
      "Number":164,
      "Name":"DongHe-ZhuanJiYin",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/0f71f0ae-8d82-4049-aadf-0b22d57a9809.JPG"
  },
  {
      "Number":165,
      "Name":"FeiLaiHong",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/0f79d20b-2816-408f-8775-256f4b7dc50d.jpg"
  },
  {
      "Number":166,
      "Name":"HongHuaJianLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/610131d0-2ebc-4e7b-bfda-49e14736c063.JPG"
  },
  {
      "Number":167,
      "Name":"HongKeLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/04614f8f-f640-4156-a5fe-1809bb15c2b6.jpg"
  },
  {
      "Number":168,
      "Name":"JiFeiLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/638cadc7-046d-4d53-95fe-a0875d2a0416.jpg"
  },
  {
      "Number":169,
      "Name":"JingGuang2",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/a42e07c2-b913-452e-aa61-fc2d7563390a.JPG"
  },
  {
      "Number":170,
      "Name":"SaiMeiGui",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/01bf8e7e-0b14-4b3d-a89f-73dc14d96e20.jpg"
  },
  {
      "Number":171,
      "Name":"ShuHongLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/29e7acee-d00a-494b-a9b9-2b9b29dc6782.jpg"
  },
  {
      "Number":172,
      "Name":"SunWenLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/ad819b15-4a1e-4303-856c-5fd77228b658.jpg"
  },
  {
      "Number":173,
      "Name":"TengHuLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/57914f53-7a29-48fd-8959-6845744fde83.jpg"
  },
  {
      "Number":174,
      "Name":"WeiShanDaoHongHe",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":""
  },
  {
      "Number":175,
      "Name":"XiaFei",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/35a0b4d5-c47e-4a7d-be0a-d36e980c28c4.jpg"
  },
  {
      "Number":176,
      "Name":"XiaoShaoYao",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/338dcc16-5149-45e9-abf9-75e5c77b8ac9.jpg"
  },
  {
      "Number":177,
      "Name":"XinHong",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/b4af7fbc-56bd-4ef3-9dcd-7f722431795c.JPG"
  },
  {
      "Number":178,
      "Name":"YanZhiHong",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/bb90905d-9d29-4a9e-81d4-daf20b12c3bf.JPG"
  },
  {
      "Number":179,
      "Name":"ZhongRiYouYiLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/1ac75ae7-8cb7-4d8c-b42f-ad6915410537.JPG"
  },
  {
      "Number":180,
      "Name":"GuLangXiaoHong",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/45930804-d649-451e-8b39-049f47504208.jpg"
  },
  {
      "Number":181,
      "Name":"HongChaWanLian",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/84c28528-8b59-4a3c-b020-5bf086812ab8.jpg"
  },
  {
      "Number":182,
      "Name":"HongXiuQiu",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/4c944cc0-fc89-416c-8e1d-282b993c4f59.jpg"
  },
  {
      "Number":183,
      "Name":"YanYangTian",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/97aad2c2-7b25-455c-b8cd-2a3025a9c9c6.jpg"
  },
  {
      "Number":184,
      "Name":"CunSanLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/7fac2c06-9a22-44f0-9292-bfbd018bac1f.JPG"
  },
  {
      "Number":185,
      "Name":"DaHeLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/73e9dfa9-4a0d-413f-97d6-0b9ef05bff98.jpg"
  },
  {
      "Number":186,
      "Name":"DongHuChunXiao",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/19addf05-b446-4abe-90df-a9c6e8b3ec60.jpg"
  },
  {
      "Number":187,
      "Name":"DongShanHongKeLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/9f24f44b-bd1b-46ed-bef2-d29d89246801.jpg"
  },
  {
      "Number":188,
      "Name":"DongGuaLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/cd544a2d-3fd3-4bc9-8b72-83a2f1e3ae5d.jpg"
  },
  {
      "Number":189,
      "Name":"DongTingHuYeLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2f59a0c9-520a-48f7-b7f3-e05f08cf71fc.jpg"
  },
  {
      "Number":190,
      "Name":"DunHuangHongLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/6d2e5c83-e01e-473c-9cce-379e2064f455.jpg"
  },
  {
      "Number":191,
      "Name":"FeiTianGuLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/29f5eccc-2741-4030-93b6-d1a66243f746.jpg"
  },
  {
      "Number":192,
      "Name":"FenDieYi",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/d93a3a61-a469-496d-b273-04df1a6fcba7.JPG"
  },
  {
      "Number":193,
      "Name":"FenHongLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/77cc3fd5-e05d-4019-bd27-e9d4207674e9.JPG"
  },
  {
      "Number":194,
      "Name":"HongLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/d78e893f-b8a7-4dd7-a004-e8a01b601ff0.jpg"
  },
  {
      "Number":195,
      "Name":"HuaiHaiHongLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/889f987f-258f-47b9-9dae-c1ce4c50b7d6.jpg"
  },
  {
      "Number":196,
      "Name":"JiZhouHongLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/a0c861ca-3501-456b-9111-507e71aa6cd4.jpg"
  },
  {
      "Number":197,
      "Name":"JieFangHongLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2b8d736c-62d8-4199-b4ea-46f0027500e7.png"
  },
  {
      "Number":198,
      "Name":"NiHeLuLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/dc8c0a1c-16af-4924-8c59-de144a5be7bf.JPG"
  },
  {
      "Number":199,
      "Name":"PaoZi",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2b1f819d-65f3-4b3d-8576-d4a07ee53b64.jpg"
  },
  {
      "Number":200,
      "Name":"PuLanDianGuLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/9813e6fe-e9cb-4005-8a19-9aefd2ffd172.jpg"
  },
  {
      "Number":201,
      "Name":"QingLianZi",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/71a4e692-b314-496c-9f51-a55315c85963.JPG"
  },
  {
      "Number":202,
      "Name":"TanKong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/f79c90ae-02d7-4426-9689-49496e74ae81.JPG"
  },
  {
      "Number":203,
      "Name":"XiangLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/63924568-b27c-4cfb-b852-ca8337f85c12.JPG"
  },
  {
      "Number":204,
      "Name":"XuanLianLaoPinZhong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/401bee6a-ebb6-41ef-b335-3b66e13dd4a0.jpg"
  },
  {
      "Number":205,
      "Name":"YaZhouLian(HongHuGongYuanJuQun)",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/73487e1f-b46d-481b-8547-c646af5ee329.jpg"
  },
  {
      "Number":206,
      "Name":"YaZhouLian(HuBeiBaoAnHuJuQun)",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/8b6dbc5e-4abc-470d-8e14-356457b5167c.jpg"
  },
  {
      "Number":207,
      "Name":"YaZhouLian(TengZhouJuQun)",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/01c55d49-2905-4b45-a002-c5bd6f4cf3cc.jpg"
  },
  {
      "Number":208,
      "Name":"YouYiHong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/716372b2-6365-481f-a13d-ac403a52d4b1.jpg"
  },
  {
      "Number":209,
      "Name":"ZhiHong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/65629f0a-8b1d-4f25-ab0e-8082f73d0306.jpg"
  },
  {
      "Number":210,
      "Name":"ZhongGuoHong.XiBaiPo",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/35e095af-2f76-43df-92f5-5645c90e3874.jpg"
  },
  {
      "Number":211,
      "Name":"ZhuZhuangOu",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/6e990707-52c5-4c30-96af-fdf602d61b30.JPG"
  },
  {
      "Number":212,
      "Name":"AiHong",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Few-petaled",
      "pic_url":""
  },
  {
      "Number":213,
      "Name":"YiXianLian",
      "Plant type":"Large size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/842549d9-7b4b-45ee-a894-a970272dbdf3.JPG"
  },
  {
      "Number":214,
      "Name":"ChuTian11",
      "Plant type":"Medium to large size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/92240e37-f714-4927-8746-553992938059.JPG"
  },
  {
      "Number":215,
      "Name":"ChunBai",
      "Plant type":"Medium to large size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/6d68d9a9-6e2e-44ca-bfec-4fdfd61850a1.jpg"
  },
  {
      "Number":216,
      "Name":"HuangWuFei",
      "Plant type":"Medium to large size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/f624aeed-a873-43ad-a162-6ea339f3e82d.jpg"
  },
  {
      "Number":217,
      "Name":"LiYaZi",
      "Plant type":"Medium to large size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/dae492fc-fc0b-4277-b86d-f8877a92639c.jpg"
  },
  {
      "Number":218,
      "Name":"AoYunLian",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/64207046-893f-4015-b427-b979382edb65.png"
  },
  {
      "Number":219,
      "Name":"BingXin",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/e18a765e-8024-4107-aead-2485b1528d83.png"
  },
  {
      "Number":220,
      "Name":"HuangHe",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/16019019-1e49-42f8-b96a-f9fc9c7b472c.JPG"
  },
  {
      "Number":221,
      "Name":"HuangYuan",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/00f08b97-726e-4cab-bd39-d2730aee0a38.jpg"
  },
  {
      "Number":222,
      "Name":"JinHui",
      "Plant type":"Medium size",
      "Flower color":"Yellow-white with red tips",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/30d4eef6-821d-45fa-b8be-81f36bb0aee5.jpg"
  },
  {
      "Number":223,
      "Name":"LvHe",
      "Plant type":"Small size",
      "Flower color":"Yellow-green",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/e605f2c9-e802-4328-a2b0-5e949d843104.jpg"
  },
  {
      "Number":224,
      "Name":"AiJiangNan",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/8634fabf-dfee-4131-81d5-d24f59cdf0df.JPG"
  },
  {
      "Number":225,
      "Name":"ChuShuiHuangLi",
      "Plant type":"Small size",
      "Flower color":"Yellow",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/4611a4b0-41c2-44a8-b20b-48aa7619163f.JPG"
  },
  {
      "Number":226,
      "Name":"HuangQue",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2b4653eb-e1b8-4326-a50e-e92f6a0b83f7.JPG"
  },
  {
      "Number":227,
      "Name":"XingHuang",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/cadb9857-ba28-415f-b28a-094233b64059.JPG"
  },
  {
      "Number":228,
      "Name":"JinFuQu",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/6af83ac1-6818-494e-86bc-8250f0d492fb.png"
  },
  {
      "Number":229,
      "Name":"JinSiHou",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/e8f7d928-5c7f-42c6-bfde-3eb16646c70d.JPG"
  },
  {
      "Number":230,
      "Name":"LiuChaoJinFen",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/0f264bf1-9245-4675-ae52-eb930976fa98.jpg"
  },
  {
      "Number":231,
      "Name":"MeiZhouHuangLian",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/2ad8fcd6-7e92-443e-a911-080ef0a3f28b.JPG"
  },
  {
      "Number":232,
      "Name":"NanJingHuang",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/4f39c72a-4916-4fb8-98bf-16bae5dbd5dd.jpg"
  },
  {
      "Number":233,
      "Name":"DanSaJin",
      "Plant type":"Medium to large size",
      "Flower color":"Variegated",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/42b6ffbe-d6cf-4f05-b3e0-db391f91e9af.jpg"
  },
  {
      "Number":234,
      "Name":"QiuRiHongHua",
      "Plant type":"Large size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/8ca8bff4-6f48-4dec-855f-8b84fdfb42c9.JPG"
  },
  {
      "Number":235,
      "Name":"GuiLi",
      "Plant type":"Small size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/7bfaa5ca-f106-4fb7-898d-e190922b118b.JPG"
  },
  {
      "Number":236,
      "Name":"JuZi",
      "Plant type":"Small to medium size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/a35c91cb-19f5-4c71-8f12-d77b6efe2412.JPG"
  },
  {
      "Number":237,
      "Name":"ZhengYiLian",
      "Plant type":"Small to medium size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/385868f0-a705-42bb-b068-5ccf7a9b0224.jpg"
  },
  {
      "Number":238,
      "Name":"DongFu",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/f926edbc-431f-42ed-abf9-800851f91e91.JPG"
  },
  {
      "Number":239,
      "Name":"JinLingHuoDou",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/015b6b3b-9d3f-4bfc-8461-06aa468f6ff8.JPG"
  },
  {
      "Number":240,
      "Name":"YiJianLian",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/f63ba48a-7d21-4cd6-a4b9-94bcbca85ef2.jpg"
  },
  {
      "Number":241,
      "Name":"MuDanZhong",
      "Plant type":"Medium to large size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/f703f3ea-68d3-485e-b790-556ae8a95aff.jpg"
  },
  {
      "Number":242,
      "Name":"JiangFuQu",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/237f3a10-2355-47f8-9910-497db9ed9f7a.JPG"
  },
  {
      "Number":243,
      "Name":"ZhongGuoHong.BeiJing",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Few-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/42d94b51-36c4-4e1a-9e81-99b94768cc87.jpg"
  },
  {
      "Number":244,
      "Name":"QianBanLian",
      "Plant type":"Large size",
      "Flower color":"Pinkish white",
      "Flower shape":"Thousand-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/c6c25c6d-d150-474c-b6d8-e30f94692de0.jpg"
  },
  {
      "Number":245,
      "Name":"YiLiangQianBan",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Thousand-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/d30aff4a-4958-4cb0-b5d7-11d8b80e3131.JPG"
  },
  {
      "Number":246,
      "Name":"ZhiZunQianBan",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Thousand-petaled",
      "pic_url":"\/api\/static\/GermplasmInformation\/d230636a-3cf9-4833-b31a-915441f407e9.jpg"
  },
  {
      "Number":247,
      "Name":"LuanFengYu",
      "Plant type":"Medium to large size",
      "Flower color":"White with green tips",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d4e581ff-a3ef-47a8-a241-d2f2504319cc.jpg"
  },
  {
      "Number":248,
      "Name":"AoDaLiYaLian",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3ee63a4b-f531-46ab-a475-11c865d16d8a.JPG"
  },
  {
      "Number":249,
      "Name":"BaiHaiLian",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/eb1bf53b-dbf0-4a35-a196-dc39ecd81407.JPG"
  },
  {
      "Number":250,
      "Name":"BaiShaoYaoLian",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6db29756-373e-4937-ab63-8bf33f8b8e72.png"
  },
  {
      "Number":251,
      "Name":"BaiXueGongZhu",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ed94c0e3-ed2d-4371-ba3f-807bc5f9a161.png"
  },
  {
      "Number":252,
      "Name":"DaBaiJu",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3d87a540-24fa-422a-8147-929497b41ba6.jpg"
  },
  {
      "Number":253,
      "Name":"DanYue-CuoWu",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":""
  },
  {
      "Number":254,
      "Name":"QingXia",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/8e9b1773-f057-4eaf-96da-9d8894015c8e.jpg"
  },
  {
      "Number":255,
      "Name":"TianGaoYunDan",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/7f7983e5-aeb0-490a-b150-a69cc5097b9c.JPG"
  },
  {
      "Number":256,
      "Name":"XueLiXingJun",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/4399824a-0dd2-49fa-8974-e1e1cc98721c.JPG"
  },
  {
      "Number":257,
      "Name":"YiZhangQing",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c3f5c69f-c344-4ed0-ab7f-710030dc161c.png"
  },
  {
      "Number":258,
      "Name":"ZhongNanHaiGuLian",
      "Plant type":"Large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1ae2e65a-ed11-433a-b168-5687de774e98.jpg"
  },
  {
      "Number":259,
      "Name":"HuoGuang",
      "Plant type":"Small size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/afd50900-2700-4070-8c06-938be159682a.jpg"
  },
  {
      "Number":260,
      "Name":"XiaoBiLian",
      "Plant type":"Small size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c622b9b8-2016-4dff-9a8b-af5245064736.jpg"
  },
  {
      "Number":261,
      "Name":"AoShuang",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3ee284ac-fdd3-4be6-8a00-a52e82026ca7.JPG"
  },
  {
      "Number":262,
      "Name":"BaiWanWan",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/448a9eb1-63fb-48ca-a25b-c09a4f804616.png"
  },
  {
      "Number":263,
      "Name":"ChangeBenYue",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/60588682-0b39-4edd-b3fc-687ad1f288c8.png"
  },
  {
      "Number":264,
      "Name":"ChunShuiLvBo",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/265aa650-b258-41c0-b0d3-c283d2d71232.jpg"
  },
  {
      "Number":265,
      "Name":"JiCuiLian",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f2199cf5-9ab0-414b-9997-5c2c303d2565.jpg"
  },
  {
      "Number":266,
      "Name":"ShuiJingBai",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/77d03e35-886c-4e1e-971f-b47429d040f3.jpg"
  },
  {
      "Number":267,
      "Name":"TaiGeShouXing",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e262b15c-814f-450b-9797-f59f349175b6.JPG"
  },
  {
      "Number":268,
      "Name":"TaiZhenChuYu",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/da2db8d8-20b5-4659-b6c3-28e769af03ba.jpg"
  },
  {
      "Number":269,
      "Name":"XinJiaPoLian",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1c437e1a-6beb-4d96-88b1-ce8870020648.jpg"
  },
  {
      "Number":270,
      "Name":"XueCuiLian",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/8dda627a-f629-43c3-98b1-88f355202219.jpg"
  },
  {
      "Number":271,
      "Name":"YuBanBai",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/21ecf221-c6ee-4a6b-8713-313eebca5c9a.jpg"
  },
  {
      "Number":272,
      "Name":"ZhiGaoWuShang",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/bb061120-1b84-47d3-a025-bbcc13ea3652.JPG"
  },
  {
      "Number":273,
      "Name":"BaiGeZhongBan",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/75e680c5-9223-433c-81d5-cfb5dafc73f0.png"
  },
  {
      "Number":274,
      "Name":"BaiMuDan",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d780b051-a3e4-436e-844b-f078508e4321.png"
  },
  {
      "Number":275,
      "Name":"BaiQianYe",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/49f7e937-309f-45bf-82d6-121362abbad4.JPG"
  },
  {
      "Number":276,
      "Name":"ErSe",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c5bf9886-a3a5-4f7c-b999-66e36bbf4cfd.jpg"
  },
  {
      "Number":277,
      "Name":"HuangYing",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1e69ddc5-96b0-4837-9848-9e48810cda86.jpg"
  },
  {
      "Number":278,
      "Name":"QingHe",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/40aa55b7-b2cf-44b4-b697-a6caa467c1a4.JPG"
  },
  {
      "Number":279,
      "Name":"QingLianGuNiang",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/dd7d1835-9550-46f1-9d6a-90d7b434017c.JPG"
  },
  {
      "Number":280,
      "Name":"ZhongBanYiZhangQing",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5de4ce81-736f-42db-ba22-97f0f10a7a23.png"
  },
  {
      "Number":281,
      "Name":"SaiFoZuo",
      "Plant type":"Large size",
      "Flower color":"White with red tips",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f2a40f0c-e4a9-4983-8e05-20d021be6547.jpg"
  },
  {
      "Number":282,
      "Name":"LuShanBaiLian",
      "Plant type":"Medium to large size",
      "Flower color":"White with red tips",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5ad85abc-1621-4e22-a789-aa4d0ac23ae5.jpg"
  },
  {
      "Number":283,
      "Name":"HuangMuDan",
      "Plant type":"Small to medium size",
      "Flower color":"Light yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/a825976c-de34-48e8-89cc-73243a3859ac.JPG"
  },
  {
      "Number":284,
      "Name":"JunYuLian",
      "Plant type":"Small to medium size",
      "Flower color":"Light yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ab2e1432-96ec-4d5b-8634-a6c0a8ccabaa.jpg"
  },
  {
      "Number":285,
      "Name":"QianBaiWan",
      "Plant type":"Small to medium size",
      "Flower color":"Light yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/a124258c-10ac-471d-add3-e883585bd8cd.jpg"
  },
  {
      "Number":286,
      "Name":"YunJin",
      "Plant type":"Medium size",
      "Flower color":"Light yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/8cc711c0-1fdd-45f0-8a7d-d80931f76078.JPG"
  },
  {
      "Number":287,
      "Name":"YangZhouWanLian",
      "Plant type":"Small size",
      "Flower color":"Pinkish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/10452d66-1546-405c-a068-a816a235953b.jpg"
  },
  {
      "Number":288,
      "Name":"BaiYunLian",
      "Plant type":"Medium to large size",
      "Flower color":"Pinkish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5f742f18-40aa-4a1a-92a6-7b9dc0ae909e.JPG"
  },
  {
      "Number":289,
      "Name":"TianJiao",
      "Plant type":"Medium to large size",
      "Flower color":"Pinkish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5d3d0080-9eca-4da0-852c-416214194d6d.JPG"
  },
  {
      "Number":290,
      "Name":"YanXinZhuang",
      "Plant type":"Medium to large size",
      "Flower color":"Pinkish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1f7165ed-522c-407b-bdf2-5d6eccf41760.jpg"
  },
  {
      "Number":291,
      "Name":"FengHuangLing",
      "Plant type":"Medium size",
      "Flower color":"Pinkish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5b81e906-3e47-4a8b-ad46-d3b8ef85e9c1.JPG"
  },
  {
      "Number":292,
      "Name":"JuWuBa",
      "Plant type":"Medium size",
      "Flower color":"Pinkish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1a5045e5-acca-47dc-9dc8-c1ba9355f4ca.JPG"
  },
  {
      "Number":293,
      "Name":"ChunBuLao",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/27719ffa-0247-41e7-8e1d-cba7af39999d.jpg"
  },
  {
      "Number":294,
      "Name":"CuiHeHongYan",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e6187953-8677-4d25-9254-344e802f7126.jpg"
  },
  {
      "Number":295,
      "Name":"HongXing",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/4f4ee043-3213-4230-be1f-057ce2f97f24.jpg"
  },
  {
      "Number":296,
      "Name":"BaoShiHua",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5a86349d-0e75-44fb-a87f-5ecec78e87d6.JPG"
  },
  {
      "Number":297,
      "Name":"LuoXia",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/de0e1286-8942-4469-a13e-fdc7daf070e6.JPG"
  },
  {
      "Number":298,
      "Name":"FuHua",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/05807bbb-5936-4bff-a108-c68b92751b09.jpg"
  },
  {
      "Number":299,
      "Name":"HongLuoZhang",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f1651768-0995-4361-a461-9bcccf5c98c1.JPG"
  },
  {
      "Number":300,
      "Name":"DaOu",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/62fc0715-1539-443d-a007-2e907e7ec991.jpg"
  },
  {
      "Number":301,
      "Name":"ChunGuang",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/09dd501b-8f44-4f07-be17-5df29ca22d8f.JPG"
  },
  {
      "Number":302,
      "Name":"HongWanWan",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ef25a244-0882-402f-8504-9f21b0f71d9f.jpg"
  },
  {
      "Number":303,
      "Name":"JingNv",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/7036ffc0-951e-4152-b274-ddb11326fba6.jpg"
  },
  {
      "Number":304,
      "Name":"ZuiYanTuo",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e41ab39b-4321-4a4e-94a5-357da601e38d.png"
  },
  {
      "Number":305,
      "Name":"HongChun",
      "Plant type":"Small to medium size",
      "Flower color":"Pinkish yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/b8739185-12de-401d-b56f-c930ed50374c.jpg"
  },
  {
      "Number":306,
      "Name":"ChunHongZhengYan",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/53a0faa2-ac88-49d1-9e79-bff1c85871d9.jpg"
  },
  {
      "Number":307,
      "Name":"HuaLi",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/8014c4a2-8a19-45a1-8acb-e1f31f0d6856.png"
  },
  {
      "Number":308,
      "Name":"JinFuRong1",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":""
  },
  {
      "Number":309,
      "Name":"LuShanHongLian",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2b07ed85-ea0f-4708-9582-86236d736da9.jpg"
  },
  {
      "Number":310,
      "Name":"QiuSanSe",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2c0884af-1edb-4bc0-9ed5-475188638188.png"
  },
  {
      "Number":311,
      "Name":"TiDengShangYue",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f6e3a4c4-efe1-403f-aa13-9293340dc1fc.JPG"
  },
  {
      "Number":312,
      "Name":"WanErHong",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f9ff0e3a-3e52-4b32-982a-77123d8bb790.jpg"
  },
  {
      "Number":313,
      "Name":"XingHuaChunYu",
      "Plant type":"Large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2c2c4391-f615-4075-a063-63d0e4591775.jpg"
  },
  {
      "Number":314,
      "Name":"FenGuoSe",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/db9be1ec-b8d6-415a-bc74-fe02329411a8.JPG"
  },
  {
      "Number":315,
      "Name":"CaiHong",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5a261e00-1a78-4c4d-a4f4-006fb5797434.png"
  },
  {
      "Number":316,
      "Name":"ChaoJinBian",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/90692490-894d-47fd-aaa0-0a1fdeb6ffb2.png"
  },
  {
      "Number":317,
      "Name":"DuoMu",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/dd037aea-42b2-447d-b022-6d6d0cb21b75.jpg"
  },
  {
      "Number":318,
      "Name":"FenHongTuoCui",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/97164c38-be28-4b55-b820-d10f7a9751d4.JPG"
  },
  {
      "Number":319,
      "Name":"FenLingYun",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5c24a4b3-f15c-45c5-a84e-96f41a5f1d95.jpg"
  },
  {
      "Number":320,
      "Name":"FenQianYe",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/960ab5a9-b628-48c0-9ced-46d670187cd2.jpg"
  },
  {
      "Number":321,
      "Name":"FoZuo",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f1b4c292-e991-424f-a6f4-cb093d3caa74.jpg"
  },
  {
      "Number":322,
      "Name":"HongFuRong",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f784d507-757c-4c68-82d2-4fec409e611d.jpg"
  },
  {
      "Number":323,
      "Name":"JinFuRong3",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":""
  },
  {
      "Number":324,
      "Name":"JinXiaHanCui",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/62bc1f0f-9f9a-45c7-ba0a-ad96d1158e9d.jpg"
  },
  {
      "Number":325,
      "Name":"JingGuang3",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/88205c2c-48a2-4fd6-83b6-fb760b749ae3.JPG"
  },
  {
      "Number":326,
      "Name":"JingZhi10",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6926eed9-9d29-454d-a906-0b26d0bdb5bb.jpg"
  },
  {
      "Number":327,
      "Name":"RuYanHuan",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3629f010-5ac2-4060-985b-b29a118e9f50.jpg"
  },
  {
      "Number":328,
      "Name":"ShengJiaoRong",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/97667ca5-9760-4241-9dc8-4de1b4df28a3.jpg"
  },
  {
      "Number":329,
      "Name":"ShouXingTao",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c3d511d1-e92c-459e-88c1-dfca5082a91b.jpg"
  },
  {
      "Number":330,
      "Name":"XiDanHong",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/63afd6a6-d65d-4fe0-aec7-495df319fa75.jpg"
  },
  {
      "Number":331,
      "Name":"XingKongMuDan",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3aff36e4-473b-4f56-b20d-3c98251c2587.JPG"
  },
  {
      "Number":332,
      "Name":"ZhongBanBaYiLian",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f9d2a65a-9d19-488a-a18f-05353e1b9061.jpg"
  },
  {
      "Number":333,
      "Name":"ZhongBanJianXuan",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/a71d4d40-7ee9-404e-8966-0eaf8fc028b9.JPG"
  },
  {
      "Number":334,
      "Name":"ZhongChuanTai",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6651d73b-5c6c-4088-afca-eac3feb4a74d.JPG"
  },
  {
      "Number":335,
      "Name":"ChuShuiFuRong",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/fd90f710-fdaf-4a63-88c7-b9e40ba5d53b.jpg"
  },
  {
      "Number":336,
      "Name":"JinHongQiaoDui",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/700d287f-a051-427a-8278-52a0df1e2a1a.jpg"
  },
  {
      "Number":337,
      "Name":"JinBianWanLian",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/82870d0c-af87-4d50-bf29-e4e868933400.jpg"
  },
  {
      "Number":338,
      "Name":"LouHuaNong",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c7ca3f81-5177-466c-80a3-c82a02896700.JPG"
  },
  {
      "Number":339,
      "Name":"XiaoQinTai",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3b62b327-21dc-45ba-96f5-be1f27c4c071.jpg"
  },
  {
      "Number":340,
      "Name":"YuHuanDanZhuang",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/a8ffa387-5bf8-4189-8c55-fe2afaa11375.jpg"
  },
  {
      "Number":341,
      "Name":"YuLouRenZui",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/4f322b34-69e5-4279-8201-dcf5bca62fc6.jpg"
  },
  {
      "Number":342,
      "Name":"CuiBengBeng",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/0a5ca57e-b17d-4a58-973a-92db7d9038d9.jpg"
  },
  {
      "Number":343,
      "Name":"DaFeng",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/fefd1f73-7a18-4b41-8f95-109e5d622c63.jpg"
  },
  {
      "Number":344,
      "Name":"DianJiangChun",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/94b3baf6-a504-4990-a5ba-aa8398724cce.jpg"
  },
  {
      "Number":345,
      "Name":"FenDai",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/fce0d73a-579f-4664-96e7-ca02e43f17f3.jpg"
  },
  {
      "Number":346,
      "Name":"FenKui",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6788990b-e44c-4e7b-b16b-ecca4c756175.jpg"
  },
  {
      "Number":347,
      "Name":"FenLingLong",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d9402b79-5e0e-47f4-a491-8fed932dab23.jpg"
  },
  {
      "Number":348,
      "Name":"FenZiXuanXin",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e81f3b26-eb8d-4da6-8317-7d0099b058b8.jpg"
  },
  {
      "Number":349,
      "Name":"FengXueMiMan",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ddf36e90-9b1e-49c2-aeab-7e5190757b90.JPG"
  },
  {
      "Number":350,
      "Name":"GuiFeiChuYu",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/aac6983d-257e-4b7b-a3f3-261701a17fab.JPG"
  },
  {
      "Number":351,
      "Name":"HongHe",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/84c9ca00-d1c8-49fd-b001-3f3dcfa8eb5c.JPG"
  },
  {
      "Number":352,
      "Name":"HongNaoLvSao",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5f0630c5-2602-41b5-97e6-c7c9f7280df1.JPG"
  },
  {
      "Number":353,
      "Name":"JianBanFenZhuang",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2cf13a76-93fb-4e1f-80e9-b6af3aa2854b.JPG"
  },
  {
      "Number":354,
      "Name":"JiangNanBiHan",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/005a7339-e2bc-47d5-9eb9-5f39cda52875.JPG"
  },
  {
      "Number":355,
      "Name":"JiaoRongSanBian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6e9433a8-0227-4299-a3b2-96876c40fc57.JPG"
  },
  {
      "Number":356,
      "Name":"JinFuRong2",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/eb7fd44e-dc3e-4288-b3cb-4f44bf1f8530.jpg"
  },
  {
      "Number":357,
      "Name":"JinJiangZhang",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/602964d9-913f-4187-bc4c-2f835b651cbd.JPG"
  },
  {
      "Number":358,
      "Name":"LouBanChun",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c9db2cf1-aa01-4dd1-82cb-85499162cf10.jpg"
  },
  {
      "Number":359,
      "Name":"LvFangHanZhu",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/7d03c86c-cfef-41cd-9e7a-4e2b6f8785c3.jpg"
  },
  {
      "Number":360,
      "Name":"QiaLouYanZhi",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/92444f9d-acc8-4fdd-9ec3-e03a39038a67.jpg"
  },
  {
      "Number":361,
      "Name":"QianCheng",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/74fee33c-361b-48d9-9878-c698dd84d17e.jpg"
  },
  {
      "Number":362,
      "Name":"QiuShuiChangTian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/65158698-2017-4210-ba7d-36895b9d361f.jpg"
  },
  {
      "Number":363,
      "Name":"RenMianTaoHua",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/cee78665-3958-426b-9483-eca5b5d1a1d6.jpg"
  },
  {
      "Number":364,
      "Name":"SanSeLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5c62d362-3733-4ad3-b0c7-9ca1829100ac.jpg"
  },
  {
      "Number":365,
      "Name":"ShengXianFenLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/750d3d80-25a4-48b3-9c57-2c5b3153be52.jpg"
  },
  {
      "Number":366,
      "Name":"Tai5",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/df8e14f9-72e6-454f-a175-3abfe3f3dd61.JPG"
  },
  {
      "Number":367,
      "Name":"TangWan",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/a18b5cbd-a5fa-4679-8d60-3acea662e422.jpg"
  },
  {
      "Number":368,
      "Name":"WenJunFuHong",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c7020e36-0a86-4d37-9885-8f536a03aa41.jpg"
  },
  {
      "Number":369,
      "Name":"XiYangYang",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ea50dfe7-8eac-4f67-94a1-90ff1ed3bbc7.jpg"
  },
  {
      "Number":370,
      "Name":"XianTao",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/64001d6c-d257-4c68-aa10-3ce4c05d4b50.JPG"
  },
  {
      "Number":371,
      "Name":"XiaoFengLiangYue",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/8c1821c4-1c53-4dda-8e79-1b8f32da6d4c.JPG"
  },
  {
      "Number":372,
      "Name":"XiaoXia",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/13878a41-4abf-4b34-be7f-bca882479754.JPG"
  },
  {
      "Number":373,
      "Name":"Ya4",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/79f9ee33-10c1-4627-ba40-1b64ce6b40a1.JPG"
  },
  {
      "Number":374,
      "Name":"YaoChiQingNuan",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/792e15e9-502c-4d56-970c-82d36f778a00.jpg"
  },
  {
      "Number":375,
      "Name":"YeYuWenXian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d9bd0d40-30ef-4601-9e07-6cbfc17d62ad.jpg"
  },
  {
      "Number":376,
      "Name":"ZuiYun",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d224d77e-26e6-4c78-a607-4167775e708b.JPG"
  },
  {
      "Number":377,
      "Name":"ZiRui",
      "Plant type":"Large size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/aba58207-3ddb-426c-9fb6-e3f710876a37.JPG"
  },
  {
      "Number":378,
      "Name":"JuHuaHe",
      "Plant type":"Small size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/02d86698-0033-48d9-a841-4d7078a33704.JPG"
  },
  {
      "Number":379,
      "Name":"FuGuiLian",
      "Plant type":"Small to medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/00823421-8225-44df-8cf0-b9519d3bdea3.jpg"
  },
  {
      "Number":380,
      "Name":"NiChangYuYi",
      "Plant type":"Small to medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/58682f40-f727-4656-9940-d28850dd058b.jpg"
  },
  {
      "Number":381,
      "Name":"QingRenJie",
      "Plant type":"Small to medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/573bc01b-0317-496d-8819-fc326a7dab90.JPG"
  },
  {
      "Number":382,
      "Name":"DieLianHua",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/089528bd-e863-4667-91bc-8562360dcd26.jpg"
  },
  {
      "Number":383,
      "Name":"JinLingChangXiang",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5f492975-e817-4c2e-a21a-a1ae423b2e4f.JPG"
  },
  {
      "Number":384,
      "Name":"MeiTaiGuanYin",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/7ad61d26-a2f9-4891-a290-7072a713528c.jpg"
  },
  {
      "Number":385,
      "Name":"RenYinFengShou",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/673d8d52-c5ec-416b-b0eb-72b6d8be3cc0.jpg"
  },
  {
      "Number":386,
      "Name":"SiLuoKuMuFuRen",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5dd4d02c-4fe2-4d5d-ac27-37909caaa07b.jpg"
  },
  {
      "Number":387,
      "Name":"XinYuHuaQing",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/9ced7e53-116b-4b5d-aa54-fa05918a8f49.JPG"
  },
  {
      "Number":388,
      "Name":"YuPeng",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/526fe877-5e02-4c53-9e31-e584ef03bc22.jpg"
  },
  {
      "Number":389,
      "Name":"BoLiFuRen",
      "Plant type":"Medium to large size",
      "Flower color":"Red and yellow bicolor",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/caa74156-2231-4d88-8c31-ae20011f80aa.JPG"
  },
  {
      "Number":390,
      "Name":"FenZhong",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":""
  },
  {
      "Number":391,
      "Name":"FengJuanHongQi",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3b648dcd-288d-48a5-a577-eec291c9d05b.JPG"
  },
  {
      "Number":392,
      "Name":"TaiKongHongQi",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/975a5136-bad2-43cf-b275-92640ab60956.JPG"
  },
  {
      "Number":393,
      "Name":"YanYangGaoZhao",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/7bf45ca6-655f-4a62-9156-21ed58a29e8e.jpg"
  },
  {
      "Number":394,
      "Name":"ZhongBanFenHongLian",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/46ec5f13-eb01-4c71-93c7-b74ee3f85958.jpg"
  },
  {
      "Number":395,
      "Name":"ZiYu",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/969c31b6-39e9-461b-9b32-4d0b8a2fcf84.png"
  },
  {
      "Number":396,
      "Name":"NiChang",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/679e88c5-5151-4980-ac55-55270f43085e.jpg"
  },
  {
      "Number":397,
      "Name":"ShenQing",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/df730b6f-4716-4c98-8d20-829b2f2e387c.JPG"
  },
  {
      "Number":398,
      "Name":"DaZiYu",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f9beb23e-b1a8-4635-820c-d153a8f6e62d.jpg"
  },
  {
      "Number":399,
      "Name":"FenHongLingXiao",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/23910d3a-b8f5-411c-89a6-3c58aab06671.JPG"
  },
  {
      "Number":400,
      "Name":"FuRongZhengYan",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/0d02da45-45b1-4201-b281-00ebb29b7de9.jpg"
  },
  {
      "Number":401,
      "Name":"GongDeng",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e7ed6e2e-6b31-4320-9009-2bb8e3b58a52.JPG"
  },
  {
      "Number":402,
      "Name":"HongDengLong",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6146b4d8-50e8-442c-930e-7f3d7592b803.JPG"
  },
  {
      "Number":403,
      "Name":"HongMuDan",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ab694b60-51bf-41ec-8624-886f06b6f5bb.jpg"
  },
  {
      "Number":404,
      "Name":"HongQianYe",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/457bdd17-abb2-4433-aa8c-ece6d0ead673.JPG"
  },
  {
      "Number":405,
      "Name":"HongShi",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d797312a-83c6-4b64-b418-4b00da68657e.jpg"
  },
  {
      "Number":406,
      "Name":"HuoJu",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/34042603-6142-40d6-8397-ce500ef8aa5f.JPG"
  },
  {
      "Number":407,
      "Name":"JuBo",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/05016303-2cbf-4a10-adc7-3a6d11ffe279.jpg"
  },
  {
      "Number":408,
      "Name":"QiaoShou",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/895b042c-f2c7-40ed-81e7-9050fa6478a8.JPG"
  },
  {
      "Number":409,
      "Name":"QiuFuRong",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e0594533-ee58-4d3e-b690-80a3cbf0e90d.JPG"
  },
  {
      "Number":410,
      "Name":"QiuHongYang",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/4e82a194-c974-4366-aa31-34e267c7f81c.JPG"
  },
  {
      "Number":411,
      "Name":"QiuJiangChun",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":""
  },
  {
      "Number":412,
      "Name":"QiuYan",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/9c9b2e35-9bf4-4b56-8c73-d83898df853d.JPG"
  },
  {
      "Number":413,
      "Name":"QuAoLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/8ecb85cd-933b-48ea-9d54-906440ec7391.jpg"
  },
  {
      "Number":414,
      "Name":"XiAnHongLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1985c4c2-6a45-491f-9155-3de2a897143c.jpg"
  },
  {
      "Number":415,
      "Name":"YinHongQianYe",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/b006247b-e53f-4c42-a145-6c9b4de99402.JPG"
  },
  {
      "Number":416,
      "Name":"YinDuLian",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ffb90233-498e-4fbd-9cdf-b9104cd0d545.jpg"
  },
  {
      "Number":417,
      "Name":"YuJiYanZhuang",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d20b40e7-b394-4858-a74f-6be20b2004fe.jpg"
  },
  {
      "Number":418,
      "Name":"ZhuYanHanXiao",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f9046ad7-0f81-4c88-b8c2-3300ce5e253c.png"
  },
  {
      "Number":419,
      "Name":"ZiXiuQiu",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/fed4cebc-a907-45b3-bed9-0cf99076089f.png"
  },
  {
      "Number":420,
      "Name":"AnTouChun",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/84a0e2c3-b9ed-4ecf-a0a0-d6547cb95b05.JPG"
  },
  {
      "Number":421,
      "Name":"HongTongShuai",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c6475ef4-24a4-4985-a058-a7968abbb188.jpg"
  },
  {
      "Number":422,
      "Name":"HongWuQun",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3cf1c765-174d-486c-b3d8-df3c8ef0dd8c.jpg"
  },
  {
      "Number":423,
      "Name":"PiZhenHong",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/88621870-f506-4d95-a568-28ceaac78952.JPG"
  },
  {
      "Number":424,
      "Name":"TangZhaoTiSiLian",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/9aec07c6-95e2-42fd-ad27-10e0586a0c3d.jpg"
  },
  {
      "Number":425,
      "Name":"XiaoLi",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/9f52310d-77f1-4d2c-ae17-2899c095d7fb.jpg"
  },
  {
      "Number":426,
      "Name":"ZhuoShangLian",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5dd1a6fb-f5ba-47cb-88a9-733b111ceacf.JPG"
  },
  {
      "Number":427,
      "Name":"BeiSunGeZhuangGuLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d7c70317-77ec-43cc-b864-5ea71c703add.JPG"
  },
  {
      "Number":428,
      "Name":"FenWaLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/5d9ef356-c1f4-4ae5-b811-b3602bea0126.jpg"
  },
  {
      "Number":429,
      "Name":"GuoQingHong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/4265b1ca-d729-40a7-8174-74b77f307334.jpg"
  },
  {
      "Number":430,
      "Name":"HongHua",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/73ef1400-8b48-4be0-b9dd-1bcff1f0b0a0.JPG"
  },
  {
      "Number":431,
      "Name":"HongSao",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6fea88d3-f880-489e-a417-db5ca0018db9.jpg"
  },
  {
      "Number":432,
      "Name":"HongShaoYaoLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/45c2befd-cafa-4f80-b053-3e15641d2a55.jpg"
  },
  {
      "Number":433,
      "Name":"HongYanSanBaiZhong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/420f986a-d0c8-4b25-987e-a1ee3ce00f43.jpg"
  },
  {
      "Number":434,
      "Name":"HongYingTao",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3e4cb755-95d0-4558-a756-0a129d2041bb.jpg"
  },
  {
      "Number":435,
      "Name":"JiXiangLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/7935abcc-f2ee-4141-b0ea-3655711b9b6e.jpg"
  },
  {
      "Number":436,
      "Name":"ManJiangHong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e20bde81-c3f9-4720-933b-b3591f57536b.jpg"
  },
  {
      "Number":437,
      "Name":"MoBao",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/dd19109a-cb3c-4e64-a0d9-47cde1b77ddf.jpg"
  },
  {
      "Number":438,
      "Name":"XianHuaOu",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/224ca2b0-b388-474e-b22d-f64250c0bdd4.jpg"
  },
  {
      "Number":439,
      "Name":"XieZhaoHong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d78e9b30-f530-4b0b-bcf1-bea34bf1df25.jpg"
  },
  {
      "Number":440,
      "Name":"XinXue",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/421bb0a8-b4ac-4480-956f-7c60ae64888e.jpg"
  },
  {
      "Number":441,
      "Name":"XinPiZhenHong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2727097d-2601-4194-a7e3-a95a8332a1e1.JPG"
  },
  {
      "Number":442,
      "Name":"XinShenQing",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6ebe6494-4ab8-49bd-939f-6b6064158388.jpg"
  },
  {
      "Number":443,
      "Name":"YiMengSong",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/f5fc3ee7-3b94-458d-966b-181b012ce11e.jpg"
  },
  {
      "Number":444,
      "Name":"YuXiuLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/4cea3517-7cb7-47f8-98df-6cab3afbedee.jpg"
  },
  {
      "Number":445,
      "Name":"ZhongGuoHong.JingGangShan",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1136768c-85fa-4420-b634-e23a4b60b949.jpg"
  },
  {
      "Number":446,
      "Name":"ZhuFu",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/75d58bc3-0502-4dac-a2c9-97c568c4ba4d.png"
  },
  {
      "Number":447,
      "Name":"ZhuoYue",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c2256ef3-4e63-4c73-8999-6e78507e6fd9.JPG"
  },
  {
      "Number":448,
      "Name":"ZiGuangGe",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2a6fd131-b604-4537-9b8f-69f28fd10cb2.png"
  },
  {
      "Number":449,
      "Name":"ZiLuoLan",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d5b0001c-709d-44d6-8b8a-bb5b53c1f75b.png"
  },
  {
      "Number":450,
      "Name":"ZiChongYang",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/2d2d4809-c37f-4a82-a8c6-81aa5730dcbc.png"
  },
  {
      "Number":451,
      "Name":"BaiJu",
      "Plant type":"Medium to large size",
      "Flower color":"Yellowish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/852d237b-1881-4b39-8f6f-a141ca1754cf.JPG"
  },
  {
      "Number":452,
      "Name":"JinSeYangGuang",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/b17667c7-14aa-43b7-a097-d591e1c6ec35.JPG"
  },
  {
      "Number":453,
      "Name":"JuLian",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/66cb71d4-b611-422c-beb8-04f831e6f30b.JPG"
  },
  {
      "Number":454,
      "Name":"PuJinDieCui",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c04062bf-f6f0-4e6c-bf07-74e6fcfcdd52.jpg"
  },
  {
      "Number":455,
      "Name":"YouYiMuDanLian",
      "Plant type":"Large size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c13d5174-8e69-4fc7-80bb-973cfb94dd6c.JPG"
  },
  {
      "Number":456,
      "Name":"NanZhaoXueFeng",
      "Plant type":"Medium to large size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/cfa56331-bc09-4fe5-8234-fc24362716cf.jpg"
  },
  {
      "Number":457,
      "Name":"QiuMuDan",
      "Plant type":"Medium to large size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/0cdbe1e2-2148-43c7-889d-879eb4bb05b9.JPG"
  },
  {
      "Number":458,
      "Name":"HuangLingYang",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/82753df1-d351-4053-b9ec-6e74a3b33fd0.jpg"
  },
  {
      "Number":459,
      "Name":"JinYuManTang",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/bbb62a1c-6695-4ad6-9b88-f5dd6d6b6253.jpg"
  },
  {
      "Number":460,
      "Name":"ChiXiangJinZhan",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/32a06b92-ab30-45c3-8838-2c252506ef7e.jpg"
  },
  {
      "Number":461,
      "Name":"FuRongChuShui",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/c1a82914-4851-406d-9b24-30adab757472.jpg"
  },
  {
      "Number":462,
      "Name":"HuangJinLun",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/3bf4481e-a56b-4320-add2-3ab2e2af1346.jpg"
  },
  {
      "Number":463,
      "Name":"JinLangFanTeng",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d293c4c3-0b74-4ae9-9706-d6bfcfcc5a1f.jpg"
  },
  {
      "Number":464,
      "Name":"MoLingQiuSe",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/9c022db7-b59a-4ee8-ba76-f9841251e210.JPG"
  },
  {
      "Number":465,
      "Name":"WuJian",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/570f83d6-9f04-454c-9a13-936889195e1a.jpg"
  },
  {
      "Number":466,
      "Name":"YanChengFeiCui",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/0af96e5c-ebb7-4c4d-85a0-04e848aefa0b.jpg"
  },
  {
      "Number":467,
      "Name":"DaSaJin",
      "Plant type":"Large size",
      "Flower color":"Variegated",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/cf1c2076-ce52-4a73-9eb7-18b462f5c401.JPG"
  },
  {
      "Number":468,
      "Name":"XiaoSaJin",
      "Plant type":"Medium to large size",
      "Flower color":"Variegated",
      "Flower shape":"Double",
      "pic_url":""
  },
  {
      "Number":469,
      "Name":"PingTing-CuoWu",
      "Plant type":"Large size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":""
  },
  {
      "Number":470,
      "Name":"SaiLingXiao",
      "Plant type":"Large size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/af9d0d29-0a26-4546-918d-7052c3b41415.JPG"
  },
  {
      "Number":471,
      "Name":"WuZhiZi2",
      "Plant type":"Large size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e3c8dba6-5081-4196-acd5-7bc90ad67168.JPG"
  },
  {
      "Number":472,
      "Name":"ZhiZunLingXiao",
      "Plant type":"Large size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/ad82137a-135e-422c-af9e-9ab38636e56d.jpg"
  },
  {
      "Number":473,
      "Name":"HongLingDieWu",
      "Plant type":"Medium to large size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/e23eadf6-0310-48da-80ed-02b5d051bcf4.jpg"
  },
  {
      "Number":474,
      "Name":"ShenQiuXiangHe",
      "Plant type":"Medium to large size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/1735e596-321b-4dd0-a439-b29163b38962.jpg"
  },
  {
      "Number":475,
      "Name":"GuangHui",
      "Plant type":"Small to medium size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/52533d77-f337-4d82-97a7-0fed0edf1b30.JPG"
  },
  {
      "Number":476,
      "Name":"CanRuoQianYang",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/6196433d-ea7f-484a-bc50-b100c3d4a644.png"
  },
  {
      "Number":477,
      "Name":"MoHong",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/d8dcb7a3-d7fe-4236-9668-1e9f549908e2.jpg"
  },
  {
      "Number":478,
      "Name":"ZhuBi",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/063678fa-a02d-44fe-902d-f8c7da3f784b.png"
  },
  {
      "Number":479,
      "Name":"ZiYe",
      "Plant type":"Medium size",
      "Flower color":"Dark red",
      "Flower shape":"Double",
      "pic_url":"\/api\/static\/GermplasmInformation\/8911230d-9d61-431e-b1c1-261e0e7203ab.png"
  },
  {
      "Number":480,
      "Name":"QingLv",
      "Plant type":"Small size",
      "Flower color":"White-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/f9c01685-49bf-4e31-824b-136dffd51433.jpg"
  },
  {
      "Number":481,
      "Name":"BaiQiu",
      "Plant type":"Small size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/15c660e8-d789-4f9c-9d9e-be6caa6a5c81.png"
  },
  {
      "Number":482,
      "Name":"FenSeDanQing",
      "Plant type":"Small size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/340e33ff-52b4-440d-96c2-98aaf58dbcb6.JPG"
  },
  {
      "Number":483,
      "Name":"LiuYeBai",
      "Plant type":"Small size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/25730810-366a-4949-a9b5-403cda27e35c.JPG"
  },
  {
      "Number":484,
      "Name":"XiaoZhiZi",
      "Plant type":"Small size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/91679fc7-deec-4bee-83b4-38dd7660bd4b.JPG"
  },
  {
      "Number":485,
      "Name":"GuangHanGong",
      "Plant type":"Medium to large size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/bf33ad42-5778-4647-98d0-182a45fb8232.JPG"
  },
  {
      "Number":486,
      "Name":"BoZhongYueYing",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/0353e65c-ef9e-4f64-be9a-b6d84b69f91f.png"
  },
  {
      "Number":487,
      "Name":"JinQiu",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/65d0552c-c4fe-4ea1-8adf-b23db155fa59.jpg"
  },
  {
      "Number":488,
      "Name":"RuiXue",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/2c5985b8-9af7-4201-81f9-f62a45ab4a42.jpg"
  },
  {
      "Number":489,
      "Name":"YinHe",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/e46cb9a7-ea20-4db1-8167-160fe6ecf115.jpg"
  },
  {
      "Number":490,
      "Name":"ZaoBaiXue",
      "Plant type":"Small to medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/f2a93867-224a-4c63-98f7-b2e0fee6d0d6.JPG"
  },
  {
      "Number":491,
      "Name":"DieYuWangShu",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/12b04f22-ccc1-4ed1-9f36-d9e2695d6504.JPG"
  },
  {
      "Number":492,
      "Name":"LuXiLian",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/5ba607e0-b9e0-463c-a4b7-a6edeb8c1b48.jpg"
  },
  {
      "Number":493,
      "Name":"ShenZhouMei.e",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/7daad90f-3acc-4a03-8583-2c90f51bb96a.jpg"
  },
  {
      "Number":494,
      "Name":"ZhuFengCuiYing",
      "Plant type":"Medium size",
      "Flower color":"White",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/e9dc3e74-a3ba-45f5-b0f5-b26dbb053423.png"
  },
  {
      "Number":495,
      "Name":"XinPiPaCheng",
      "Plant type":"Medium size",
      "Flower color":"Orange",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/61264544-6654-4d5d-a80a-4efae1fc53ec.JPG"
  },
  {
      "Number":496,
      "Name":"JinPingGuo",
      "Plant type":"Medium size",
      "Flower color":"Light yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/72e25bf2-73ae-410c-ab04-581befbed823.png"
  },
  {
      "Number":497,
      "Name":"HongTaiLian",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/97ee29cd-487f-486b-9bd2-821ca9bb6683.JPG"
  },
  {
      "Number":498,
      "Name":"DongFangMingZhu",
      "Plant type":"Small size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/9f4277ba-ab84-4e2e-b97a-9bc756032a5e.JPG"
  },
  {
      "Number":499,
      "Name":"ShenZhouMei.Hei",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/25367134-7644-4cf5-8c14-ed52463066db.JPG"
  },
  {
      "Number":500,
      "Name":"YunTengXiaWei",
      "Plant type":"Medium to large size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/15b67387-71b9-4256-8c07-3a72cffdc756.jpg"
  },
  {
      "Number":501,
      "Name":"BaWangHua",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/8184e080-5551-484b-a4f8-c7bab5aa1a81.png"
  },
  {
      "Number":502,
      "Name":"LongFuZhiGuang",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/0fb461e5-a5d6-47e8-9eaf-049eeff042a9.jpg"
  },
  {
      "Number":503,
      "Name":"ZuiDongFeng",
      "Plant type":"Small to medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/b98136cd-f686-4227-9854-ed70c245bb64.png"
  },
  {
      "Number":504,
      "Name":"FeiHong",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/dc94f28d-840d-4bcd-bfb9-3ca93bcf5286.JPG"
  },
  {
      "Number":505,
      "Name":"FenCengTuoCui",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":""
  },
  {
      "Number":506,
      "Name":"FoZuoLian",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/e899e7aa-f422-4352-bc6f-39d0d228bd42.jpg"
  },
  {
      "Number":507,
      "Name":"JiMingMuGu",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/480e485c-f3fa-4cf9-a59e-b8c5161b6e80.jpg"
  },
  {
      "Number":508,
      "Name":"MeiHongZhongTai",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/8053f8cf-e540-4bc6-b2a4-60af0d40a6a2.jpg"
  },
  {
      "Number":509,
      "Name":"NanZhaoFoGuang",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/f43cda50-ee71-48bc-b233-d62168eb0d7f.jpg"
  },
  {
      "Number":510,
      "Name":"QianDuiJin",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/13b31ae6-5053-4ae0-9dc1-a859705329af.jpg"
  },
  {
      "Number":511,
      "Name":"QinHuaiJiangSheng",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/8332c865-082d-4c9d-98e0-3b1a337feee3.jpg"
  },
  {
      "Number":512,
      "Name":"XingYu",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/80b1000e-8967-4a31-b485-f6647fbb5ddd.JPG"
  },
  {
      "Number":513,
      "Name":"YueHua",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/24e976b3-42c0-4d40-a15d-874b1daad6ff.jpg"
  },
  {
      "Number":514,
      "Name":"ZhaoJunGuYing",
      "Plant type":"Medium size",
      "Flower color":"Pink",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/e50e7e82-d220-429a-949a-b7a8297100cf.jpg"
  },
  {
      "Number":515,
      "Name":"LongPingLian",
      "Plant type":"Small to medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/d3d4116c-127a-4e08-aaa2-69639f49b3ab.jpg"
  },
  {
      "Number":516,
      "Name":"CaiYun",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/b8ef728f-0a18-4ac3-a2c0-ec3b2aa16e30.JPG"
  },
  {
      "Number":517,
      "Name":"ShenZhouMei.Cang",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/c5645020-23e2-4892-b425-fa89462dfb2b.jpg"
  },
  {
      "Number":518,
      "Name":"ShiChengJinXiu",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/356125ee-38d5-4010-9e7f-b6f5825beb90.jpg"
  },
  {
      "Number":519,
      "Name":"YeYuJiuShi",
      "Plant type":"Medium size",
      "Flower color":"Multicolored",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/d7c4a6cf-0516-4d36-ae25-7f9436d2bd25.jpg"
  },
  {
      "Number":520,
      "Name":"ZhongShanHongTai",
      "Plant type":"Large size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/44d9b1a1-eeb8-4ff4-ad30-354f868192b2.JPG"
  },
  {
      "Number":521,
      "Name":"HongYanDiCui",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":""
  },
  {
      "Number":522,
      "Name":"ShuiMeiRen",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/b5eccb66-8ba8-417d-9442-107fec330e31.JPG"
  },
  {
      "Number":523,
      "Name":"TaoHongSuYu",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/df1cca2e-4476-4612-b896-d9728249f0a5.JPG"
  },
  {
      "Number":524,
      "Name":"XiaoNiChang",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/cd7ef940-b2b2-4111-98ed-326d747c415d.jpg"
  },
  {
      "Number":525,
      "Name":"ZiQiDongLai",
      "Plant type":"Small size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/8e0e7862-0195-44d6-9059-f6e0e79f57c7.png"
  },
  {
      "Number":526,
      "Name":"HongLou",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/22579773-1739-4790-a515-a339dc4c0a6e.JPG"
  },
  {
      "Number":527,
      "Name":"JunJie",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/e04aedae-2275-45fc-8d1a-8878b010ef8b.JPG"
  },
  {
      "Number":528,
      "Name":"RiChu",
      "Plant type":"Medium to large size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/078ef6eb-0787-441f-9472-8ad1b82687fc.jpg"
  },
  {
      "Number":529,
      "Name":"DanXiuQiu",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/edc2507a-e1a2-49b7-a21e-4d9a6a46df26.jpg"
  },
  {
      "Number":530,
      "Name":"DongHuXiZhao",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/f3ddca6d-94ec-4864-9f0e-319bbbf59feb.jpg"
  },
  {
      "Number":531,
      "Name":"HongYun",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/1f716857-eef2-45fb-b511-9f6520ce7ee6.jpg"
  },
  {
      "Number":532,
      "Name":"ZhenYouMei",
      "Plant type":"Small to medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/58d32392-87f5-4265-8ea9-1b03c34efa29.JPG"
  },
  {
      "Number":533,
      "Name":"GuangYueLou",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/e22929d9-8a35-4b60-8992-83cc624eb1ab.JPG"
  },
  {
      "Number":534,
      "Name":"HongZhanTuoZhu",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/d431a5dc-4681-483b-b8be-3a3fac953d81.JPG"
  },
  {
      "Number":535,
      "Name":"JingYan",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/19d472ce-e9b2-4eb2-8b4d-650e3303b57b.JPG"
  },
  {
      "Number":536,
      "Name":"QianTangHongLou",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/9ba7f064-10bb-4e0d-9031-6c159a5967c0.jpg"
  },
  {
      "Number":537,
      "Name":"ZhanHongTu",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/7438b5ac-733c-49ef-b3ac-9d007ea416e5.JPG"
  },
  {
      "Number":538,
      "Name":"ZhongGuoHong.NanJing",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/6f185cc5-b2ed-4dec-9e2f-cee2c6bdbb7e.jpg"
  },
  {
      "Number":539,
      "Name":"ZiYuLian",
      "Plant type":"Medium size",
      "Flower color":"Red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/129d28bc-1021-482b-8586-233507160ef7.png"
  },
  {
      "Number":540,
      "Name":"XinJie",
      "Plant type":"Medium size",
      "Flower color":"Yellowish white",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/7ed3f003-ee3a-44da-8c9e-0eb98de30d78.jpg"
  },
  {
      "Number":541,
      "Name":"LvZhu",
      "Plant type":"Small size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/04ae7a08-396d-490b-bd53-6e409f951925.jpg"
  },
  {
      "Number":542,
      "Name":"LvRuYi",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/380c6bf6-f3b4-497b-9360-26c2220e9a5c.JPG"
  },
  {
      "Number":543,
      "Name":"JinCuiMuDan",
      "Plant type":"Medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/c59b5bd1-8d97-4d98-bcf4-cda52479a589.JPG"
  },
  {
      "Number":544,
      "Name":"JinTong",
      "Plant type":"Medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/df2d1e35-2d51-49d3-90c7-9c6a53cf35c4.JPG"
  },
  {
      "Number":545,
      "Name":"Lve",
      "Plant type":"Medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/22a9d9f7-a6c3-4873-b620-2be0e233ae86.JPG"
  },
  {
      "Number":546,
      "Name":"LvMeng",
      "Plant type":"Medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/08b62dcc-e84c-4a74-9100-59a8a80a7eb6.jpg"
  },
  {
      "Number":547,
      "Name":"ShiChengFeiCui",
      "Plant type":"Medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/4086cef6-6ad7-4224-afaa-f6a653722402.jpg"
  },
  {
      "Number":548,
      "Name":"TaoLingFengQing",
      "Plant type":"Medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/45e9aaa5-5e77-425a-b86d-10091baa5caa.jpg"
  },
  {
      "Number":549,
      "Name":"ZhenGuoHuang",
      "Plant type":"Medium size",
      "Flower color":"Yellow-green",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/6a332edc-7da2-48d4-8398-4059b75f37f7.jpg"
  },
  {
      "Number":550,
      "Name":"BaoYun",
      "Plant type":"Small size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/93f730ae-3922-434a-8d85-dc759a9c2239.JPG"
  },
  {
      "Number":551,
      "Name":"BiBoLiuYing",
      "Plant type":"Small size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/d3af320c-e375-423f-94db-4427bedebf41.png"
  },
  {
      "Number":552,
      "Name":"CaoYuanZhiXing",
      "Plant type":"Small size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/4880afa9-7861-4476-9958-2778a1ee1ed8.JPG"
  },
  {
      "Number":553,
      "Name":"YeChengYuXiu",
      "Plant type":"Small size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/b585ae1f-41af-46df-975f-1ace91430ace.JPG"
  },
  {
      "Number":554,
      "Name":"JinRuYi",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/a066efb8-a0fe-4afb-b1c4-e1b3898f954f.jpg"
  },
  {
      "Number":555,
      "Name":"XiangXueHai",
      "Plant type":"Small to medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/84f289f8-61f2-4111-8dcb-b8de69a8e928.jpg"
  },
  {
      "Number":556,
      "Name":"aYuWang",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/4b3fff99-ae2b-4edf-ad71-2f22d837b235.png"
  },
  {
      "Number":557,
      "Name":"CaoYuanZhiMeng",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/2776e136-6ba8-4921-beb4-17e9da6025ef.JPG"
  },
  {
      "Number":558,
      "Name":"JinFengXiuSe",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/5ab5eb1b-95ce-428e-87a5-64b8bad72941.JPG"
  },
  {
      "Number":559,
      "Name":"JinShanCaiXia",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/993d8cb6-984b-4ec9-8ab7-de72c9a1ca48.jpg"
  },
  {
      "Number":560,
      "Name":"JinWuYongCui",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/2e42e330-fa4d-4a61-93be-fab68e17091b.jpg"
  },
  {
      "Number":561,
      "Name":"RuRun",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/f6c84333-65b4-4877-9f49-f0628d7075b0.jpg"
  },
  {
      "Number":562,
      "Name":"TaiChengFeiCui",
      "Plant type":"Medium size",
      "Flower color":"Yellow",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/68cb2c07-579f-4a91-8829-2496f9e55728.jpg"
  },
  {
      "Number":563,
      "Name":"HongBaoShi",
      "Plant type":"Small to medium size",
      "Flower color":"Dark red",
      "Flower shape":"Multi-staminate",
      "pic_url":"\/api\/static\/GermplasmInformation\/4eebaf6a-6823-411a-b3ae-0b4e8274403e.JPG"
  },
  {
      "Number":564,
      "Name":"BaiYuZan1",
      "Plant type":"Large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":565,
      "Name":"MianChengOu",
      "Plant type":"Large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":566,
      "Name":"PingTouZi",
      "Plant type":"Large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":567,
      "Name":"XuanWuHuHongLian",
      "Plant type":"Large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":568,
      "Name":"YuShanHongLian",
      "Plant type":"Large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":569,
      "Name":"YingTaoXiaoKou",
      "Plant type":"Small size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":570,
      "Name":"eLian13",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":571,
      "Name":"FenYuLian",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":572,
      "Name":"HeiLongJiangHongLian",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":573,
      "Name":"HuaXiangOu",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":574,
      "Name":"JiLinYeLian",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":575,
      "Name":"QueZiYangZi",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":576,
      "Name":"TaiBaiLian",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":577,
      "Name":"YingQuanXiKe",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":578,
      "Name":"ChangJieLiuYueBao",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":579,
      "Name":"ZhuJieOu",
      "Plant type":"Medium to large size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":580,
      "Name":"GuanYinLian",
      "Plant type":"Small to medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":581,
      "Name":"JianZuiHongHua",
      "Plant type":"Small to medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":582,
      "Name":"BaiYingLian",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":583,
      "Name":"BeiJingBaiHuaOu",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":584,
      "Name":"DaFangTou",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":585,
      "Name":"DaHongKe",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":586,
      "Name":"DaJin",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":587,
      "Name":"DaMaoJie",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":588,
      "Name":"eLian4",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":589,
      "Name":"eLian6",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":590,
      "Name":"FeiHuang",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":591,
      "Name":"FenLou",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":592,
      "Name":"HuaOu",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":593,
      "Name":"JianPuZhaiLian",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":594,
      "Name":"JiaoPa",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":595,
      "Name":"JiaoNiang",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":596,
      "Name":"KaiFengGuLian",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":597,
      "Name":"LiHuaBai",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":598,
      "Name":"LiaoChengXiangLian",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":599,
      "Name":"LuTouZhong",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":600,
      "Name":"PiaoHuaOu",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":601,
      "Name":"XiaRuoYouWuLang",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":602,
      "Name":"XiangTanHuaYeOu",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":603,
      "Name":"XiaoXiQueTou",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":604,
      "Name":"XingChengOu",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":605,
      "Name":"YaChengOu",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":606,
      "Name":"YiMengHongLian",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":607,
      "Name":"ZhiMaHuOu",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":608,
      "Name":"ZuiChun",
      "Plant type":"Medium size",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":609,
      "Name":"AoHanLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":610,
      "Name":"BaYiLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":611,
      "Name":"ChuLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":612,
      "Name":"GongXunLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":613,
      "Name":"GuiFei",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":614,
      "Name":"HeNanGuLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":615,
      "Name":"HongTaiYang",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":616,
      "Name":"HuangLi",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":617,
      "Name":"JiuHongChuanTai",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":618,
      "Name":"NanZhaoChanYin",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":619,
      "Name":"PiPaCheng",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":620,
      "Name":"PuZheHeiBaiLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":621,
      "Name":"PuZheHeiHongLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":622,
      "Name":"ShengHuo",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":623,
      "Name":"ShiChengHuoBa",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":624,
      "Name":"WeiShanHuHongHe",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":625,
      "Name":"XingHong",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":626,
      "Name":"XuanWuHongLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":627,
      "Name":"YaZhouLian(HuBeiHongHuJuQun)",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":628,
      "Name":"YaZhouLian(HuBeiLiangZiHuJuQun)",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":629,
      "Name":"YaZhouLian(HuBeiShangJinHuJuQun)",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":630,
      "Name":"YaZhouLian(HuNanJunShanJuQun)",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":631,
      "Name":"YaZhouLian(ShangHaiJuQun)",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":632,
      "Name":"YaZhouLian(YueYangTuanHuHeHuaGongYuanJuQun)",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":633,
      "Name":"YaoNiangYuJiao",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":634,
      "Name":"YingYing",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":635,
      "Name":"ZhongGuoHong.ZunYi",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":636,
      "Name":"ZhongTaiLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  },
  {
      "Number":637,
      "Name":"ZhuZhouBaiLian",
      "Plant type":"-",
      "Flower color":"-",
      "Flower shape":"-",
      "pic_url":""
  }
]
const ColumsArrTop = [];
Object.keys(resource_lotus_pic[0]).map((key) => {
  if (key == "pic_url") return;
  ColumsArrTop.push({
    key,
    title: key,
    dataIndex: key,
    align: "center",
    render: (index, item) => {
      if (key == "Name") {
        return <Tooltip title={
            <div>
                <img src={item.pic_url?`${item.pic_url}`:require('../../image/Resource/20240110120829524.png')} alt="" style={{width: "150px"}}/>
            </div>
        }>
        <span>{index}</span>
      </Tooltip>;
      } else {
        return <p>{index}</p>;
      }
    },
  });
});
export { ColumsArrTop, resource_lotus_pic };
